export default __webpack_public_path__ + "static/media/searching_3evy.79ae5184.svg";